<template>
  <div class="emd-container">
    <div class="el-section">
      <div class="eu-container">
        <div class="eu-flex eu-justify_center">
          <div
            class="eu-flex-item eu-basis_8_sm eu-basis_6_md eu-basis_5_lg eu-align_center"
          >
            <emd-alert
              v-if="emailError.status"
              variant="danger"
              :title="$t(emailError.title)"
              :message="$t(emailError.message)"
              autoclose
              @cancel="emailError.status = false"
            />
            <!-- Cartão -->
            <section
              class="el-section"
              v-if="
                showCardSuccessTexts
              "
            >
              <div class="el-chunk">
                <div class="el-chunk">
                  <span
                    class="emd-text"
                    :class="{
                      _color_warning: status === 'processing',
                      _color_success:
                        status === 'paid' || !selectedPaymentTypeItems,
                      _color_info: status === 'pending',
                    }"
                  >
                    <i
                      v-if="status === 'paid' || !selectedPaymentTypeItems"
                      class="uil uil-check-circle"
                      style="font-size: 3rem"
                    ></i>
                    <i
                      v-if="status === 'processing'"
                      class="uil uil-hourglass"
                      style="font-size: 3rem"
                    ></i>
                    <i
                      v-if="status === 'pending'"
                      class="uil uil-info-circle"
                      style="font-size: 3rem"
                    ></i>
                  </span>
                </div>
                <div class="el-chunk">
                  <h2
                    class="emd-text _size_page"
                    v-if="status === 'paid' || !selectedPaymentTypeItems"
                  >
                    {{ $t(`${selectedPaymentType}.payment.approved`) }}
                  </h2>
                  <h2
                    class="emd-text _size_page"
                    v-if="status === 'processing'"
                  >
                    {{ $t(`${selectedPaymentType}.payment.pending`) }}
                  </h2>
                  <h2 class="emd-text _size_page" v-if="status === 'pending'">
                    {{ $t(`${selectedPaymentType}.payment.auth_only`) }}
                  </h2>
                </div>
              </div>
              <p
                class="el-chunk"
                v-if="status === 'paid' || !selectedPaymentTypeItems"
              >
                {{ $t(`${selectedPaymentType}.status.approved`) }}
              </p>
              <p class="el-chunk" v-if="status === 'processing'">
                {{
                  $t(`${selectedPaymentType}.status.pending`, {
                    creditCard: creditCard,
                  })
                }}
              </p>
              <p class="el-chunk" v-if="status === 'pending'">
                {{ $t(`${selectedPaymentType}.status.auth_only`) }}
              </p>
              <order-created-share @emailError="setEmailError" />
            </section>
            <!-- ./ Cartão -->
            <!-- Boleto -->
            <section class="el-section" v-if="payment_method === 'boleto'">
              <div class="el-chunk">
                <div class="el-chunk">
                  <span class="emd-text _color_success">
                    <i class="uil uil-check-circle" style="font-size: 3rem"></i>
                  </span>
                </div>
                <div class="el-chunk">
                  <h2 class="emd-text _size_page">
                    {{ $t(`${selectedPaymentType}.payment.paid`) }}
                  </h2>
                </div>
              </div>
              <p class="el-chunk">
                {{
                  $t(`${selectedPaymentType}.status.paid.boleto`, {
                    due_at: due_at,
                    totalAmount: totalAmount,
                  })
                }}
              </p>
              <div class="el-chunk">
                <div class="emd-container _type_card">
                  <div class="emd-container__content">
                    <div
                      class="emd-copy eu-justify_center"
                      :class="{ _copied: copied }"
                      @click="copy('boleto_code')"
                    >
                      <span class="emd-copy__icon" title="copiar">
                        <i v-if="copied" class="uil uil-check-circle"></i>
                        <i v-else class="uil uil-copy-alt"></i>
                      </span>
                      <p class="emd-copy__text eu-grow_0" ref="boleto_code">
                        {{ this.createdOrderResponse.payment_url }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <order-created-share @emailError="setEmailError" />
            </section>
            <!-- ./Boleto -->
            <!-- Link -->
            <section class="el-section" v-if="payment_method === 'checkout'">
              <div class="el-chunk">
                <div class="el-chunk">
                  <span class="emd-text _color_success">
                    <i class="uil uil-check-circle" style="font-size: 3rem"></i>
                  </span>
                </div>
                <div class="el-chunk">
                  <h2 class="emd-text _size_page">
                    {{ $t(`${selectedPaymentType}.payment.paid`) }}
                  </h2>
                </div>
              </div>
              <p class="el-chunk">
                {{
                  $t(`${selectedPaymentType}.status.paid.checkout`, {
                    orderId: orderId,
                    totalAmount: totalAmount,
                  })
                }}
              </p>
              <div class="el-chunk">
                <div class="emd-container _type_card">
                  <div class="emd-container__content">
                    <div
                      class="emd-copy eu-justify_center"
                      :class="{ _copied: copied }"
                      @click="copy('payment_link')"
                    >
                      <span class="emd-copy__icon" title="copiar">
                        <i v-if="copied" class="uil uil-check-circle"></i>
                        <i v-else class="uil uil-copy-alt"></i>
                      </span>
                      <p class="emd-copy__text eu-grow_0" ref="payment_link">
                        {{ createdOrderResponse.payment_url }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <order-created-share @emailError="setEmailError" />
            </section>
            <!-- ./Link -->
            <pix-order-created
              v-if="payment_method === 'pix'"
              :paymentMethod="payment_method"
              :totalAmount="totalAmount"
            />
            <order-created-share
              @emailError="setEmailError"
              v-if="payment_method === 'pix'"
            />
            <section class="el-section">
              <div class="eu-flex eu-column eu-row_sm">
                <div class="eu-flex-item">
                  <a
                    class="emd-btn _type_text _color_primary"
                    :href="$sanitize(viewOrder)"
                    target="_blank"
                    rel="noopener"
                  >
                    <i class="uil uil-external-link-alt"></i>
                    {{ $t(`${selectedPaymentType}.viewOrder`) }}
                  </a>
                </div>
                <div class="eu-flex-item">
                  <button
                    class="emd-btn _color_primary"
                    @click="resetApplication"
                  >
                    <i class="uil uil-plus"></i>
                    {{ $t(`${selectedPaymentType}.createNew`) }}
                  </button>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { maskCreditCard } from '@/utils/validations'
import EmdAlert from '@/components/emerald/molecules/EmdAlert'
import OrderCreatedShare from '@/components/project/OrderCreatedShare'
import PixOrderCreated from '@/components/project/OrderCreated/PixOrderCreated'

export default {
  name: 'OrderCreated',
  components: {
    EmdAlert,
    OrderCreatedShare,
    PixOrderCreated
  },
  data () {
    return {
      copied: false,
      emailSent: false,
      loadingEmail: false,
      emailError: {},
      initialRoute: 'OrderType'
    }
  },
  computed: {
    payment_method () {
      return this.createdOrderResponse.payment_method
    },
    selectedPaymentType () {
      return this.$store.getters.selectedPaymentType
    },
    selectedPaymentTypeItems () {
      return this.selectedPaymentType === 'items'
    },
    selectedPaymentTypeTypedSale () {
      return this.selectedPaymentType === 'typed-sale'
    },
    showCardSuccessTexts () {
      return this.payment_method === 'credit_card' || (!this.selectedPaymentTypeItems && !this.selectedPaymentTypeTypedSale)
    },
    createdOrderResponse () {
      if (this.selectedPaymentTypeItems || this.selectedPaymentTypeTypedSale) { return this.$store.getters.createdOrderResponse.payments[0] } else return this.$store.getters.createdOrderResponse
    },
    status () {
      return this.createdOrderResponse.status
    },
    due_at () {
      return this.$store.getters.boleto.due_at
    },
    orderId () {
      return this.$store.getters.createdOrderResponse.id
    },
    accountId () {
      return this.$store.getters.accountData.id
    },
    merchantId () {
      return this.$store.getters.merchantData.id
    },
    totalAmount () {
      return this.$store.getters.total.amount
    },
    creditCard () {
      return maskCreditCard(this.$store.getters.card.number, true)
    },
    hasSubscriptionEnabled () {
      return this.$store.getters.hasSubscriptionEnabled
    },
    viewOrder () {
      const type = this.selectedPaymentTypeItems ? 'orders' : 'subscriptions'
      const info = this.selectedPaymentTypeItems ? '' : 'info'
      return `${process.env.VUE_APP_DASH_URL}/${this.merchantId}/${this.accountId}/${type}/${this.orderId}/${info}`
    }
  },
  methods: {
    resetApplication () {
      this.$store.dispatch('RESET_PAYMENT_STATE')
      this.$store.dispatch('RESET_ORDER_STATE')
      this.$store.dispatch('RESET_PERMISSION', this.initialRoute)
      this.$router.push({ name: this.initialRoute })
    },
    copy (item) {
      let element
      if (Array.isArray(this.$refs[item])) {
        element = this.$refs[item][0]
      } else {
        element = this.$refs[item]
      }
      navigator.clipboard.writeText(element.innerText)
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 2000)
    },
    setEmailError (error) {
      this.emailError = error
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name !== this.initialRoute) this.$router.go()
    else next()
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "typed-sale": {
        "payment": {
          "approved": "Pagamento aprovado",
          "pending": "Em processamento",
          "paid": "Pedido criado com sucesso!",
          "auth_only": "Pedido criado com sucesso!"
        },
        "status": {
          "approved": "Seu pedido foi realizado e o pagamento já foi aprovado, compartilhe o comprovante com o seu cliente.",
          "pending": "O pagamento no cartão de final {creditCard} está sendo processado, o status do pedido pode ser acompanhado no dash da conta.",
          "auth_only": "Seu pedido foi autorizado e está pendente de captura, compartilhe o comprovante com o seu cliente.",
          "paid": {
            "checkout": "Seu pedido {orderId} no valor de {totalAmount} pode ser pago neste link",
            "boleto": "O boleto no valor de {totalAmount} foi gerado e pode ser pago até o dia {due_at}"
          }
        },
        "viewOrder": "Visualizar pedido",
        "createNew": "Criar novo pedido"
      },
      "items": {
        "payment": {
          "approved": "Pagamento aprovado",
          "pending": "Em processamento",
          "paid": "Pedido criado com sucesso!",
          "auth_only": "Pedido criado com sucesso!"
        },
        "status": {
          "approved": "Seu pedido foi realizado e o pagamento já foi aprovado, compartilhe o comprovante com o seu cliente.",
          "pending": "O pagamento no cartão de final {creditCard} está sendo processado, o status do pedido pode ser acompanhado no dash da conta.",
          "auth_only": "Seu pedido foi autorizado e está pendente de captura, compartilhe o comprovante com o seu cliente.",
          "paid": {
            "checkout": "Seu pedido {orderId} no valor de {totalAmount} pode ser pago neste link",
            "boleto": "O boleto no valor de {totalAmount} foi gerado e pode ser pago até o dia {due_at}"
          }
        },
        "viewOrder": "Visualizar pedido",
        "createNew": "Criar novo pedido"
      },
      "subscription": {
        "payment": {
          "approved": "Recorrência agendada",
          "pending": "Recorrência criada com sucesso!"
        },
        "status": {
          "approved": "Sua recorrência foi agendada, compartilhe o comprovante com o seu cliente.",
          "pending": "O pagamento no cartão de final {creditCard} está sendo processado, o status do pedido pode ser acompanhado no dash da conta."
        },
        "viewOrder": "Visualizar recorrência",
        "createNew": "Gerar nova recorrência"
      }
    },
    "en-US": {
      "items": {
        "typed-sale": {
          "approved": "Approved Payment",
          "pending": "Processing",
          "paid": "Order created!",
          "auth_only": "Request created successfully!"
        },
        "status": {
          "approved": "Your order was created and the payment has been approved, share the ticket with your custumer.",
          "pending": "The payment with the last card digits {creditCard} is being processed, you can follow the order status at the dash account.",
          "auth_only": "Your order has been authorized and is pending capture, share the receipt with your customer.",
          "paid": {
            "checkout": "Your order {orderId} of {totalAmount} can be paid at this link",
            "boleto": "The boleto of {totalAmount} was generated and can be paid until {due_at}"
          }
        },
        "viewOrder": "View order",
        "createNew": "Create a new order"
      },
      "items": {
        "payment": {
          "approved": "Approved Payment",
          "pending": "Processing",
          "paid": "Order created!",
          "auth_only": "Request created successfully!"
        },
        "status": {
          "approved": "Your order was created and the payment has been approved, share the ticket with your custumer.",
          "pending": "The payment with the last card digits {creditCard} is being processed, you can follow the order status at the dash account.",
          "auth_only": "Your order has been authorized and is pending capture, share the receipt with your customer.",
          "paid": {
            "checkout": "Your order {orderId} of {totalAmount} can be paid at this link",
            "boleto": "The boleto of {totalAmount} was generated and can be paid until {due_at}"
          }
        },
        "viewOrder": "View order",
        "createNew": "Create a new order"
      },
      "subscription": {
        "payment": {
          "approved": "Subscription scheduled",
          "pending": "Recorrência criada com sucesso!"
        },
        "status": {
          "approved": "Your subscription has been scheduled, share the receipt with your customer.",
          "pending": "O pagamento no cartão de final {creditCard} está sendo processado, o status do pedido pode ser acompanhado no dash da conta."
        },
        "viewOrder": "View subscription",
        "createNew": "Create a new subscription"
      }
    }
  }
</i18n>
